// eslint-disable-next-line import/prefer-default-export
export function facebookTrackLead() {
  try {
    window.fbq('track', 'Lead', {
      value: 10.00,
      currency: 'USD',
    }, { eventID: sessionStorage.getItem('fb-event-id') });
  } catch (err) {
    console.error('Error tracking lead form submission for Facebook', err);
  }
}
